var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"canvas"}},[(_vm.tilesError)?_c('div',{staticClass:"tiles-error",attrs:{"role":"status"}},[_c('strong',[_vm._v(_vm._s(_vm.$t( 'viewer.threeDUnavailable' )))]),_c('span',[_vm._v(_vm._s(_vm.$t( 'viewer.threeDUnavailableDescription' )))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }